import React from "react"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "react-day-picker/dist/style.css"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { Toaster } from "sonner"

import ProtectedRoute from "@/components/ProtectedRoute"
import { TooltipProvider } from "@/components/ui/tooltip"
import { AuthProvider } from "@/contexts/AuthProvider"
import Collections from "@/pages/Collections"
import Login from "@/pages/Login"
import Signup from "@/pages/Signup"
import Access from "@/pages/admin/Access"
import Exports from "@/pages/admin/Exports"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            {/* Outside /collections/* so that wildcard cannot swallow them. */}
            <Route
              path="/admin/access"
              element={
                <ProtectedRoute>
                  <Access />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/exports"
              element={
                <ProtectedRoute>
                  <Exports />
                </ProtectedRoute>
              }
            />
            <Route path="/collections/access" element={<Navigate to="/admin/access" replace />} />
            <Route
              path="/collections/*"
              element={
                <ProtectedRoute>
                  <Collections />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/collections/monitoring" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
)

export default App
